console.debug("LOADING Discover.js")
import { PageAbstract } from "./PageAbstract"
import { rootStore } from "store/RootStore"
import { DiscoverConst } from "scenes/Discover/DiscoverConst"
import { moment } from "store/util/moment"
import { action, runInAction, computed, observable, makeObservable, flow } from "mobx"
import { SourceChannelLive } from "store/page/player/source/InternalImports"
import { eventId, endTs } from "utils/EventHelpers"
import { Mutex } from 'async-mutex'
import { EventDetailsMode } from "@quickline/coco"
import { sleep } from "utils/Utils"

//export class Discover { //extends PageAbstract {
export class Discover extends PageAbstract {
	firstTileMarginLeft = {}
	sectionTitleMarginLeft = {}
	isLaneOnHero = {}
	videoElem = null
	liveEvent = null
	intervalId = null
	playStarted = false
	_isShow = false
	_discoverCategory = null
	discoverScrollPos = null
	modalWidth = window.innerWidth
	modalHeight = window.innerHeight
	player = rootStore.page.Player.playerDiscover
	// MTVW-996: synch concurrent requests when switching Discover and LiveTv tab
	mutex = new Mutex()
	discoverAndLiveMutex = {
		mutex: null,
		owner: "",
		count: 0
	}
	timeOutId = null
	discoverClosed = true

	constructor(parent, path) {
		super(parent, path)
		//super(parent, path)
		makeObservable(this, {
			firstTileMarginLeft: observable,
			sectionTitleMarginLeft: observable,
			isLaneOnHero: observable,
			videoElem: observable,
			liveEvent: observable,
			playStarted: observable,
			_isShow: observable,
			_discoverCategory: observable,
			modalWidth: observable,
			modalHeight: observable,
			isShow: computed,
			discoverCategory: computed,
			setShow: action,
			setDiscoverCategory: action,
			setFirstTileMarginLeft: action,
			setSectionTitleMarginLeft: action,
			setVideoElem: action,
			fetchLiveEvent: action,
			setPlayStarted: action,
			setLiveEvent: action,
			setIsLaneOnHero: action,
			setModalWidth: action,
			setModalHeight: action,
			isMutexLocked: computed,
			discoverAndLiveMutex: observable
		})
		// test purpose
		/*
		setInterval(() => {
			this.inActiveEvent()
			setTimeout(() => {
				this.activeEvent()
			}, 1000)

		}, 10000)
		*/
	}

	get discoverCategory() {
		return this._discoverCategory
	}

	get isShow() {
		return this._isShow
	}

	setShow(bShow = null) {
		this._isShow = bShow === null ? !this._isShow : bShow
		return this
	}

	setModalWidth(value) {
		this.modalWidth = value
	}

	setModalHeight(value) {
		this.modalHeight = value
	}

	_onMount() {
		this._setMounted(true)
	}

	_onUnmount() {
	}

	setFirstTileMarginLeft(value, origin) {
		//console.debug("setFirstTileMarginLeft", value, origin)
		//this.firstTileMarginLeft = value
		this.firstTileMarginLeft[origin] = value
		//console.debug("setFirstTileMarginLeft", this.firstTileMarginLeft)
	}

	setSectionTitleMarginLeft(value, origin) {
		this.sectionTitleMarginLeft[origin] = value
	}

	// MTVW-996
	setVideoElem = flow(function* (videoElem) {
		this.videoElem = videoElem
		if (this.videoElem) {
			//console.debug("LiveTile", videoElem, this.discoverAndLiveMutex?.owner)
			// MTVW-1032: could be called twice from LiveTile after profile change
			if (this.discoverAndLiveMutex?.owner === this.player.__path) yield this.releaseMutex(this.player.__path)
			yield this.acquireMutex(this.player.__path)
			this.discoverClosed = false
			yield this.fetchLiveEvent()
		}
	})

	fetchLiveEvent = flow(function* () {
		//console.debug("LiveTile", this.discoverClosed, this.videoElem, rootStore.channelsService.activeChannelId)
		if (!this.videoElem) return
		// MTVW-1094: settle delay, needed in case of profile change to select proper channel
		yield sleep(1000)
		try {
			if (!this.player._refElemContainer) yield this.player.setRefElemContainer(this.videoElem, true)
			//console.debug("LiveTile fetchLiveEvent entry", this.videoElem)
			if (!rootStore.channelsService.activeChannelId) rootStore.channelsService.setActiveChannel(rootStore.channelsService.getFirstChannelListChannel)
			let chListId = rootStore.channelsService.activeChannelListId
			if (!chListId) chListId = "allChannelsListId"
			const chList = yield rootStore.channelsService.getChannelListAsync(chListId)
			if (rootStore.channelsService.indexInChannelList(rootStore.channelsService.activeChannelId) < 0) {
				const firstChannel = rootStore.channelsService.getFirstChannelListChannel
				if (firstChannel) rootStore.channelsService.setActiveChannel(firstChannel)
				else {
					yield rootStore.channelsService.getChannelListAsync("allChannelsListId")
					rootStore.channelsService.setActiveChannelListId("allChannelsListId")
					rootStore.channelsService.setActiveChannel(rootStore.channelsService.getFirstChannelListChannel)
				}
			}
			yield rootStore.page.CoCoBookmarks.getBookmarksAsync(false /*true*/)
      	// MTVW-1075: progs from CoCo
			const res = yield rootStore.page.MsEpg.getProgramsForNow()
			const currProgs = (res && typeof res.find === "function") ? res.find(i => i.channelId === rootStore.channelsService.activeChannelId) : null
			const event = currProgs?.events?.[0] ?? currProgs?.Events?.[0]
			if (event) {
				const nextFetch = endTs(event.event) - moment().utc().valueOf()
				console.debug("LiveTile fetchLiveEvent", rootStore.channelsService.activeChannelId, event, this.discoverClosed, nextFetch)
				//refreshBookmark(event.event)
				if (!this.discoverClosed) {
					this.setLiveEvent(event)
					this.timeOutId = setTimeout(() => {
						if (this.timeOutId) {
							this.fetchLiveEvent()
						}
					}, nextFetch + 3000)
				}
			}
		}
		catch (e) {
			console.error("fetchLiveEvent", e)
		}
	})

	setLiveEvent = flow(function* (event) {
		//console.debug("setLiveEvent", this.liveEvent?.event?.id, event?.id)
		yield rootStore.page.CoCoDiscover.discover(false)
		runInAction(() => {
			if (eventId(event) /*&& this.liveEvent?.event?.id !== event?.id*/) {
				this.liveEvent = event
				// use delay so that <Player> has been set up
				//if (event) setTimeout(() => {
				this.playLiveTv()
				//}, 100)

			}
		})
	})

	setIsLaneOnHero(value, origin) {
		this.isLaneOnHero[origin] = value
	}

	setDiscoverCategory(category) {
		this._discoverCategory = category
		return this
	}

	setDiscoverScrollPos(value) {
		this.discoverScrollPos = value
	}

	playLiveTv = flow(function* () {
		//console.trace("playLiveTv", this.discoverClosed, this.liveEvent?.event?.id)
		try {
			if (DiscoverConst.useLivePlayer && this.liveEvent?.event?.id) {
				// MTVW-1075: EventDetailsMode.Lite
				const event = yield rootStore.page.MsEpg.getEventDetailsAsync(this.liveEvent?.event?.id, EventDetailsMode.Lite)
				//console.debug("playLiveTv", event, this.liveEvent)	
				if (event && !this.discoverClosed) {
					this.player.setErrorCallback(this.playerError.bind(this))
					const source = SourceChannelLive.create(this, event.channelId, event, false)
					source.isOnDiscover = true
					yield source.openStreamAsync()
				}
			}
		}
		catch (e) {
			console.error("playLiveTv", e)
		}
	})

	setPlayStarted(value) {
		this.playStarted = value
	}

	playStartEvent() {
		// make sure that no modal is open now
		if (!rootStore.page.OverlayEventDetails.isShow && !this.isShow) this.setPlayStarted(true)
		else if (this.player._refElemContainer) this.player.setRefElemContainer(null, true)
	}


	playerError = flow(function* (error) {
		console.error("LiveTile playerError", error)
		// suppress error display, show Poster
		yield this.inActiveEvent()
		yield this.activeEvent()
	})

	activeEvent = flow(function* (event) {
		console.debug("LiveTile activeEvent")
		if (DiscoverConst.useLivePlayer /*&& !this.playStarted*/ && this.liveEvent?.event?.id) {
			const elem = document.getElementById("disPlayer")
			//console.debug("LiveTile", this.player, elem)
			if (elem && !this.player._refElemContainer) yield this.player.setRefElemContainer(elem, true)
			this.discoverClosed = false
			//yield this.playLiveTv()
			yield this.fetchLiveEvent()
		}
	})

	inActiveEvent = flow(function* (event) {
		console.debug("LiveTile inActiveEvent")
		this.discoverClosed = true
		clearTimeout(this.timeOutId)
		clearInterval(this.intervalId)
		this.timeOutId = null
		yield this.player.setRefElemContainer(null, true)
		this.setPlayStarted(false)
	})

	// MTVW-996
	acquireMutex = flow(function* (path) {
		console.debug("acquireMutex", path, this.discoverAndLiveMutex)
		try {
			/*if (this.discoverAndLiveMutex.owner !== path)*/ this.discoverAndLiveMutex.mutex = yield this.mutex.acquire()
			this.discoverAndLiveMutex.count++
			this.discoverAndLiveMutex.owner = path
			//if (path === "playerLiveTvVo") rootStore.page.LiveTv.playStarted = false
			console.debug("acquireMutex done", path)
		}
		catch (e) {
			console.error("acquireMutex", e)
		}
	})

	// MTVW-996
	releaseMutex = flow(function* (path) {
		//if (!this.discoverAndLiveMutex.mutex) console.trace("releaseMutex null")
		try {
			if (this.discoverAndLiveMutex?.mutex && this.discoverAndLiveMutex?.owner === path) {
				this.discoverAndLiveMutex.count--
				console.debug("releaseMutex", path)
				if (this.discoverAndLiveMutex.count === 0) {
					this.discoverAndLiveMutex.owner = ""
					this.discoverAndLiveMutex.mutex()
					//this.discoverAndLiveMutex.mutex = null
				}
			}
			else {
				console.warn("releaseMutex wrong owner", this.discoverAndLiveMutex.owner, path)
				this.discoverAndLiveMutex.count = 0
				this.discoverAndLiveMutex.owner = ""
				this.discoverAndLiveMutex.mutex?.()
			}
		}
		catch (e) {
			console.error("releaseMutex", e)
		}
	})

	// MTVW-996
	notifyTabChange = flow(function* (from, to) {
		if (from === "/" /*&& this.playStarted*/) { // navigating away from "Discover"
			//console.debug("notifyTabChange from %o, to %o", from, to)
			this.setPlayStarted(false)
			this.player.setIsPosterVisible(true, "Discover notifyTabChange", true)
			this.discoverClosed = true
			clearTimeout(this.timeOutId)
			clearInterval(this.intervalId)
			try {
				yield this.player.setRefElemContainer(null, true)
			}
			catch (e) {
				console.error("notifyTabChange", e)
			}
			finally {
				console.debug("stopped playerDiscover")
				this.releaseMutex(this.player.__path)
			}
		}

		/* handled in LiveTv.js
		if (from === "LiveTv" && to === "Discover") {
			//rootStore.page.Player.playerLiveTvVo.setRefElemContainer(null, true).then(() => {
			rootStore.page.Player.playerLiveTvVo.stopInstance().then(() => {
				console.debug("stopped playerLiveTvVo")
				this.releaseMutex("playerLiveTvVo")
				rootStore.page.LiveTv.playStarted = false
			})
		}
		*/
	})

	get isMutexLocked() {
		return this.mutex.isLocked()
	}
}
